module.exports = __webpack_public_path__ + "static/media/zoomarket.35997883.webp";